class jfAccordionController {

  constructor($state, $rootScope, XRayUIState, $timeout) {
    this.state            = $state;
    this.currentAccordion = '';
    this.XRayUIState      = XRayUIState;
    this.$timeout         = $timeout;

    this.openItemByCurrentState();

    $rootScope.$on('$stateChangeSuccess', () => this.openItemByCurrentState());
  }

  goToState(item) {
    if (!item.isDisabled) {
      this.state.go(item.state, item.stateParams);
    }
  }

  openItemByCurrentState() {
    let item = _.find(this.items, (item) => {
      return this.isItemActive(item);
    });
    if (item) item.isOpen = true;
  }

  saveState(item) {
    this.XRayUIState.setState('saveAdminState', true);
    this.goToState(item);
    /*
     // ACTUAL SAVING OF LAST ADMIN STATE MOVED TO artifactory.states.mudule.js (TO PREVENT SAVING WRONG STATE WHEN CONFIRMATION MODAL IS PRESENTED)
     this.$timeout(()=>{
     this.artifactoryState.setState('lastAdminState',this.state.current);
     this.artifactoryState.setState('lastAdminStateParams', this.state.params);
     });
     */

  }

  isItemActive(item) {
    let result = _.includes(this.state.current.name, item.state);
    /*
     if (result && item.stateParams) {
     let relevantParams = _.pick(this.state.params, Object.keys(item.stateParams));
     result = angular.equals(relevantParams, item.stateParams);
     }
     */

    return result;
  }

}

export function jfAccordion() {

  return {
    restrict: 'EA',
    scope: {items: '='},
    controller: jfAccordionController,
    controllerAs: 'jfAccordion',
    templateUrl: 'directives/jf_accordion/jf_accordion.html',
    bindToController: true
  };
}




// WEBPACK FOOTER //
// ./modules/xray/directives/jf_accordion/jf_accordion.js